// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__RU5ez","contentFullscreen":"Layout_contentFullscreen__9LGGz"};